module.exports = __webpack_public_path__ + "203b9ceeef687e8324b2f569a519cd39.png";